const add ="/system/base/add";
const detail ="/system/base/detail";
const webDetail = "/system/base/webDetail";
const isPageAllColor ="/system/base/isPageAllColor";
const getBaseInfo ="/system/base/getBaseInfo";
export default {
    add,detail,webDetail,getBaseInfo,isPageAllColor
  }